import styled from 'styled-components';

import CityPinSvg from 'assets/city-pin.svg';

export const CityPin = styled(CityPinSvg)``;

